import { moduleProviderFactory } from "core/providers";
import { PickTicketNewFlowDetailList } from "application/pick-ticket-new-flow/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.pick-ticket-new-flow.list",
						pattern: "/:facilityOrderId/pick-ticket-new-flow/:pickTicketHeaderId",
						authorization: "facilityOrderSection.read",
						component: PickTicketNewFlowDetailList,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.PICK_TICKET",
									route: 'master.app.main.facility-order.pick-ticket-new-flow.list'
								}
							]
						},
					},
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
